// v-no-space: 拦截输入框中的所有空格（含全角、Tab 等），与 v-model 配合使用
export default {
	mounted(el) {
		const input = el.tagName === 'INPUT' || el.tagName === 'TEXTAREA'
			? el
			: el.querySelector('input, textarea');
		if (!input) return;
		const handler = () => {
			const cleaned = input.value.replace(/\s/g, '');
			if (cleaned !== input.value) {
				input.value = cleaned;
				input.dispatchEvent(new Event('input', { bubbles: true }));
			}
		};
		input.addEventListener('input', handler);
		el.__noSpaceCleanup = () => input.removeEventListener('input', handler);
	},
	beforeUnmount(el) {
		if (el.__noSpaceCleanup) {
			el.__noSpaceCleanup();
			delete el.__noSpaceCleanup;
		}
	}
}
